import { locItem } from '../../../model/game';
import { loc } from '../common';

export default loc(
  2, 'Runestone_BlackForest', ['BlackForest'],
  { type: 'runestone', quantity: 50, group: 'Runestones', minApart: 128, radius: [20, 8],
  items: [locItem('RuneStone_BlackForest')] }
);

